// ** React Imports
import { useEffect, useState } from 'react';

// ** MUI Imports
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Tooltip from '@mui/material/Tooltip';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Link from '@mui/material/Link';
import { ActivityDialogStore, Lead, LeadScreenStore, ViewType } from 'src/stores/LeadStore';

// ** Custom Components
import CustomChip from 'src/materio/@core/components/mui/chip';

// ** Types
import { ThemeColor } from 'src/materio/@core/layouts/types';

import { LeadDataFormater } from 'src/features/leads/view/LeadDataFormater';
import PhoneIphoneTwoToneIcon from '@mui/icons-material/PhoneIphoneTwoTone';
import LocalPhoneTwoToneIcon from '@mui/icons-material/LocalPhoneTwoTone';
import SupportAgentTwoToneIcon from '@mui/icons-material/SupportAgentTwoTone';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailTwoToneIcon from '@mui/icons-material/EmailTwoTone';
import LanguageIcon from '@mui/icons-material/Language';
import FaxIcon from '@mui/icons-material/Fax';
import { client } from '../../../utils/axios-client';
import { loadAccountImageEndpoint, loadUserAvatarEndpoint } from '../../../configs/endpoints';
import Avatar from '@mui/material/Avatar';
import StandardSkeleton from '../../common/StandardSkeleton';
import RenderIf, { ClaimType, ClaimValue } from '../../common/RenderIf';
import { isEmpty } from 'lodash';

const DoActivityLeadInformation = () => {
    const item = LeadScreenStore.useState((s) => s.selectedLead) as Lead;
    const selectedView = LeadScreenStore.useState((s) => s.selectedView);
    const [imgSrc, setImgSrc] = useState<string>('');
    const [hasLoaded, setHasLoaded] = useState(false);

    const onEditLead = () => {
        LeadScreenStore.update((s) => {
            s.selectedLead = item;
            s.isNewPopup = true;
            s.editMode = true;
        });

        ActivityDialogStore.update((s) => {
            s.editLeadMode = true;
        });

        //selectedView == ViewType.Edit && editLeadMode
    };

    useEffect(() => {
        const loadImage = async () => {
            setHasLoaded(false);
            if (!isEmpty(item.owner.avatarFileName)) {
                const response = await client.get(loadUserAvatarEndpoint.replace('{id}', item.owner.avatarFileName));
                setImgSrc(response.data);
            } else {
            }
            setHasLoaded(true);
        };

        if (item.owner) loadImage();
    }, []);

    if (hasLoaded) {
        return (
            <Box>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card variant="outlined">
                            <CardContent>
                                <Box>
                                    <Grid container spacing={2} alignContent={'flex-end'}>
                                        <Grid
                                            item
                                            xs={12}
                                            md={6}
                                            sx={{ pt: 1, display: 'flex', alignItems: 'left', flexDirection: 'column' }}
                                        >
                                            <Typography sx={{ fontSize: 20, color: 'CornflowerBlue' }} gutterBottom>
                                                Lead Information
                                            </Typography>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            md={6}
                                            sx={{ alignItems: 'right' }}
                                            justifyContent={'flex-end'}
                                        >
                                            <RenderIf claimType={ClaimType.Leads} claimValue={ClaimValue.Edit}>
                                                <Box display="flex" justifyContent="flex-end">
                                                    <Link
                                                        underline="hover"
                                                        component="button"
                                                        variant="caption"
                                                        onClick={onEditLead}
                                                    >
                                                        Edit Lead
                                                    </Link>
                                                </Box>
                                            </RenderIf>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2} justifyContent={'center'}>
                                        <Grid item xs={12} md={12}>
                                            <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                <LeadDataFormater
                                                    labelText="Customer:"
                                                    valueText={item.customer != null ? item.customer.name : ''}
                                                    textColor=""
                                                    errorText="-Unknown-"
                                                    chipHeight={20}
                                                    chipFontSize="0.75rem"
                                                    chipfontWeight={500}
                                                    isChip={false}
                                                />
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                <LeadDataFormater
                                                    labelText="Company"
                                                    valueText={`${item.company != null ? item.company : ''}`}
                                                    textColor=""
                                                    errorText="-Unknown-"
                                                    chipHeight={20}
                                                    chipFontSize="0.75rem"
                                                    chipfontWeight={500}
                                                    isChip={false}
                                                />
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} md={12}>
                                            <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                <LeadDataFormater
                                                    labelText="Job Title"
                                                    valueText={`${item.jobTitle != null ? item.jobTitle : ''}`}
                                                    textColor=""
                                                    errorText="-Unknown-"
                                                    chipHeight={20}
                                                    chipFontSize="0.75rem"
                                                    chipfontWeight={500}
                                                    isChip={false}
                                                />
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} md={12}>
                                            <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                <LeadDataFormater
                                                    labelText="Email"
                                                    valueText={`${item.emailAddress != null ? item.emailAddress : ''}`}
                                                    textColor=""
                                                    errorText="-Unknown-"
                                                    chipHeight={20}
                                                    chipFontSize="0.75rem"
                                                    chipfontWeight={500}
                                                    isChip={false}
                                                />
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} md={12}>
                                            <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                <LeadDataFormater
                                                    labelText="Switchboard Phone"
                                                    valueText={`${
                                                        item.switchboardPhone != null ? item.switchboardPhone : ''
                                                    }`}
                                                    textColor=""
                                                    errorText="-Unknown-"
                                                    chipHeight={20}
                                                    chipFontSize="0.75rem"
                                                    chipfontWeight={500}
                                                    isChip={false}
                                                />
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} md={12}>
                                            <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                <LeadDataFormater
                                                    labelText="Mobile Phone"
                                                    valueText={`${item.mobilePhone != null ? item.mobilePhone : ''}`}
                                                    textColor=""
                                                    errorText="-Unknown-"
                                                    chipHeight={20}
                                                    chipFontSize="0.75rem"
                                                    chipfontWeight={500}
                                                    isChip={false}
                                                />
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} md={12}>
                                            <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                <LeadDataFormater
                                                    labelText="Direct Phone"
                                                    valueText={`${item.directPhone != null ? item.directPhone : ''}`}
                                                    textColor=""
                                                    errorText="-Unknown-"
                                                    chipHeight={20}
                                                    chipFontSize="0.75rem"
                                                    chipfontWeight={500}
                                                    isChip={false}
                                                />
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} md={12}>
                                            <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                <LeadDataFormater
                                                    labelText="Industry:"
                                                    valueText={item.industry != null ? item.industry.name : ''}
                                                    textColor=""
                                                    errorText="-Unknown-"
                                                    chipHeight={20}
                                                    chipFontSize="0.75rem"
                                                    chipfontWeight={500}
                                                    isChip={false}
                                                />
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                <LeadDataFormater
                                                    labelText="Source:"
                                                    valueText={item.leadSource != null ? item.leadSource.name : ''}
                                                    textColor=""
                                                    errorText="-Unknown-"
                                                    chipHeight={20}
                                                    chipFontSize="0.75rem"
                                                    chipfontWeight={500}
                                                    isChip={false}
                                                />
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                <LeadDataFormater
                                                    labelText="City:"
                                                    valueText={item.addressCity != null ? item.addressCity : ''}
                                                    textColor=""
                                                    errorText="-City is missing-"
                                                    chipHeight={20}
                                                    chipFontSize="0.75rem"
                                                    chipfontWeight={500}
                                                    isChip={false}
                                                />
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                <LeadDataFormater
                                                    labelText="Country:"
                                                    valueText={item.country != null ? item.country.name : ''}
                                                    textColor=""
                                                    errorText="-Unknown-"
                                                    chipHeight={20}
                                                    chipFontSize="0.75rem"
                                                    chipfontWeight={500}
                                                    isChip={false}
                                                />
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} md={12}>
                                            <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                <LeadDataFormater
                                                    labelText="Level:"
                                                    valueText={item.leadLevel != null ? item.leadLevel.name : ''}
                                                    textColor=""
                                                    errorText="-Unknown-"
                                                    chipHeight={20}
                                                    chipFontSize="0.75rem"
                                                    chipfontWeight={500}
                                                    isChip={false}
                                                />
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                <LeadDataFormater
                                                    labelText="Function:"
                                                    valueText={item.leadFunction != null ? item.leadFunction.name : ''}
                                                    textColor=""
                                                    errorText="-Unknown-"
                                                    chipHeight={20}
                                                    chipFontSize="0.75rem"
                                                    chipfontWeight={500}
                                                    isChip={false}
                                                />
                                            </Box>
                                        </Grid>
                                        {/*<Grid item xs={12} md={12}>*/}
                                        {/*    <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>*/}
                                        {/*        <LeadDataFormater*/}
                                        {/*            labelText="Street:"*/}
                                        {/*            valueText={item.addressStreet != null ? item.addressStreet : ''}*/}
                                        {/*            textColor=""*/}
                                        {/*            errorText="-Unknown-"*/}
                                        {/*            chipHeight={20}*/}
                                        {/*            chipFontSize="0.75rem"*/}
                                        {/*            chipfontWeight={500}*/}
                                        {/*            isChip={false}*/}
                                        {/*        />*/}
                                        {/*    </Box>*/}
                                        {/*</Grid>*/}

                                        {/*<Grid item xs={12} md={6}>*/}
                                        {/*    <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>*/}
                                        {/*        <LeadDataFormater*/}
                                        {/*            labelText="Province/State:"*/}
                                        {/*            valueText={item.addressProvince != null ? item.addressProvince : ''}*/}
                                        {/*            textColor=""*/}
                                        {/*            errorText="-Unknown-"*/}
                                        {/*            chipHeight={20}*/}
                                        {/*            chipFontSize="0.75rem"*/}
                                        {/*            chipfontWeight={500}*/}
                                        {/*            isChip={false}*/}
                                        {/*        />*/}
                                        {/*    </Box>*/}
                                        {/*</Grid>*/}
                                        {/*<Grid item xs={12} md={6}>*/}
                                        {/*    <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>*/}
                                        {/*        <LeadDataFormater*/}
                                        {/*            labelText="Postal Code:"*/}
                                        {/*            valueText={*/}
                                        {/*                item.addressPostalCode != null ? item.addressPostalCode : ''*/}
                                        {/*            }*/}
                                        {/*            textColor=""*/}
                                        {/*            errorText="-Unknown-"*/}
                                        {/*            chipHeight={20}*/}
                                        {/*            chipFontSize="0.75rem"*/}
                                        {/*            chipfontWeight={500}*/}
                                        {/*            isChip={false}*/}
                                        {/*        />*/}
                                        {/*    </Box>*/}
                                        {/*</Grid>*/}
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                            <LeadDataFormater
                                                labelText="Region:"
                                                valueText={item.addressRegion != null ? item.addressRegion.name : ''}
                                                textColor=""
                                                errorText="-Unknown-"
                                                chipHeight={20}
                                                chipFontSize="0.75rem"
                                                chipfontWeight={500}
                                                isChip={false}
                                            />
                                        </Box>
                                    </Grid>
                                    {item.referralFrom && (
                                        <Grid item xs={12}>
                                            <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                <LeadDataFormater
                                                    labelText="Referral From:"
                                                    valueText={item.referralFrom.fullName}
                                                    textColor=""
                                                    errorText="-Unknown-"
                                                    chipHeight={20}
                                                    chipFontSize="0.75rem"
                                                    chipfontWeight={500}
                                                    isChip={false}
                                                />
                                            </Box>
                                        </Grid>
                                    )}
                                    {item.referralTo && (
                                        <Grid item xs={12}>
                                            <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                <LeadDataFormater
                                                    labelText="Referral To:"
                                                    valueText={item.referralTo.fullName}
                                                    textColor=""
                                                    errorText="-Unknown-"
                                                    chipHeight={20}
                                                    chipFontSize="0.75rem"
                                                    chipfontWeight={500}
                                                    isChip={false}
                                                />
                                            </Box>
                                        </Grid>
                                    )}
                                </Box>
                                <Divider />
                                <Box>
                                    <Grid container spacing={2} justifyContent={'center'}>
                                        <Grid
                                            item
                                            xs={12}
                                            md={12}
                                            sx={{ pt: 1, display: 'flex', alignItems: 'left', flexDirection: 'column' }}
                                        >
                                            <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'left' }}>
                                                {item.mobilePhone != null && item.mobilePhone != '' && !item.dncMobile && (
                                                    <Tooltip title={'Cell/Mobile: ' + item.mobilePhone}>
                                                        <PhoneIphoneTwoToneIcon color="action" />
                                                    </Tooltip>
                                                )}
                                                {item.mobilePhone != null && item.mobilePhone != '' && item.dncMobile && (
                                                    <Tooltip title={'Cell/Mobile: ' + item.mobilePhone + ' (DNC)'}>
                                                        <PhoneIphoneTwoToneIcon color="warning" />
                                                    </Tooltip>
                                                )}

                                                {item.directPhone != null && item.directPhone != '' && !item.dncPhone && (
                                                    <Tooltip title={'Direct phone: ' + item.directPhone}>
                                                        <LocalPhoneTwoToneIcon color="action" />
                                                    </Tooltip>
                                                )}
                                                {item.directPhone != null && item.directPhone != '' && item.dncPhone && (
                                                    <Tooltip title={'Direct phone: ' + item.directPhone + ' (DNC)'}>
                                                        <LocalPhoneTwoToneIcon color="warning" />
                                                    </Tooltip>
                                                )}
                                                {item.switchboardPhone != null &&
                                                    item.switchboardPhone != '' &&
                                                    !item.dncSwitchboard && (
                                                        <Tooltip title={'Switchboard: ' + item.switchboardPhone}>
                                                            <SupportAgentTwoToneIcon color="action" />
                                                        </Tooltip>
                                                    )}
                                                {item.switchboardPhone != null &&
                                                    item.switchboardPhone != '' &&
                                                    item.dncSwitchboard && (
                                                        <Tooltip
                                                            title={'Switchboard: ' + item.switchboardPhone + ' (DNC)'}
                                                        >
                                                            <SupportAgentTwoToneIcon color="warning" />
                                                        </Tooltip>
                                                    )}
                                                {item.linkedIn != null && item.linkedIn != '' && (
                                                    <a href={item.linkedIn} target="_blank">
                                                        <Tooltip title={'LinkedIn: ' + item.linkedIn}>
                                                            <LinkedInIcon color="action" />
                                                        </Tooltip>
                                                    </a>
                                                )}
                                                {item.emailAddress != null && item.emailAddress != '' && (
                                                    <Tooltip title={'Email: ' + item.emailAddress}>
                                                        <EmailTwoToneIcon color="action" />
                                                    </Tooltip>
                                                )}
                                                {item.website != null && item.website != '' && (
                                                    <Tooltip title={'Web: ' + item.website}>
                                                        <LanguageIcon color="action" />
                                                    </Tooltip>
                                                )}
                                                {item.fax != null && item.fax != '' && (
                                                    <Tooltip title={'Fax: ' + item.fax}>
                                                        <FaxIcon color="action" />
                                                    </Tooltip>
                                                )}
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <Divider />
                                <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'left' }}>
                                    <Grid container spacing={2} justifyContent={'center'}>
                                        <Grid
                                            item
                                            xs={12}
                                            md={12}
                                            sx={{ pt: 1, display: 'flex', alignItems: 'left', flexDirection: 'column' }}
                                        >
                                            <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'left' }}>
                                                {item.owner && item.owner.fullName != '' && (
                                                    <Grid container spacing={2} justifyContent={'center'}>
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            md={1}
                                                            sx={{
                                                                pt: 1,
                                                                display: 'flex',
                                                                alignItems: 'left',
                                                                flexDirection: 'column',
                                                            }}
                                                        >
                                                            <Tooltip title="Primary lead owner">
                                                                <Avatar
                                                                    alt={item.owner.fullName}
                                                                    sx={{ width: 20, height: 20 }}
                                                                    src={imgSrc ? imgSrc : '/images/avatars/1.png'}
                                                                />
                                                            </Tooltip>
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            md={11}
                                                            sx={{
                                                                pt: 1,
                                                                display: 'flex',
                                                                alignItems: 'left',
                                                                flexDirection: 'column',
                                                            }}
                                                        >
                                                            <Tooltip title="Primary lead owner">
                                                                <Typography
                                                                    variant="caption"
                                                                    sx={{ fontStyle: 'italic' }}
                                                                >
                                                                    Owner: {item.owner.fullName}
                                                                </Typography>
                                                            </Tooltip>
                                                        </Grid>
                                                    </Grid>
                                                )}
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        );
    } else {
        return <StandardSkeleton />;
    }
};

export { DoActivityLeadInformation };
export default DoActivityLeadInformation;
